import React from 'react'

function PortfolioComponent({ title, image, link, code }) {
    return (
        <div className='bg-[#93a2b8] h-[324px] text-white group relative w-full border rounded-lg cursor-pointer hover:translate-x-1 transition-transform hover:translate-y-2 '>
            <div className='h-full w-full'>
                <img className='h-full w-full rounded-lg group-hover:opacity-10' src={image} alt={title} />
            </div>
            <div className='hidden group-hover:block p-1'>
                <div className='absolute top-1/4 flex w-full justify-center'>
                    <h1 className='font-bold capitalize '>{title}</h1>
                </div>
                <div className='absolute bottom-1/3 flex items-center w-full justify-evenly'>
                    {link && <div className='bg-[#10172a] rounded-md p-2'><a
                        href={link}
                        target="_blank"
                        rel="noreferrer">Link</a></div>}
                    <div className='bg-[#10172a] rounded-md p-2'><a
                        href={code}
                        target="_blank"
                        rel="noreferrer">Code</a></div>
                </div>
            </div>
        </div >
    )
}

export default PortfolioComponent